import { fetcher } from '../utils'
import { ComponentInfoChatVO } from '@repo/types'
import { ComponentInfoLoadVO } from '@repo/types/src/types/ComponentInfoLoadVO'

export default async (input: ComponentInfoLoadVO): Promise<ComponentInfoChatVO> =>
  fetcher(`/api/componentInfo/chat`, 'POST', input)
